import { useEffect } from "react";

import useOfferingTypeData from "../../../state/offeringTypes/UseOfferingTypeData";
import Constants from "../../../utils/Constants";

const useOfferingTypeRegistrationRadioButtonList = (orgUnitId, isOrganizationRegistration) => {
  const isDisabled = false;
  const { offeringTypeState, getOfferingTypesForClubRegistration } = useOfferingTypeData();

  useEffect(() => {
    if (offeringTypeState.isArrayLoading !== true && orgUnitId !== Constants.DEFAULT_ID) {
      getOfferingTypesForClubRegistration(orgUnitId, isOrganizationRegistration);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitId, isOrganizationRegistration]);

  return { offeringTypeState, isDisabled }
};

export default useOfferingTypeRegistrationRadioButtonList;